export default __webpack_public_path__ + "static/media/14B.050.dd027132.png";